import { useEffect, type FC } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyNavigation } from '@/services/navProgress';

/**
 * Сторож переходов. Живёт вне Suspense, поэтому реагирует на смену URL сразу —
 * в момент клика по навигации, ещё до загрузки нового чанка. Ставит «цель»
 * перехода в стор. Ничего не рендерит.
 */
export const NavigationProgressWatcher: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    notifyNavigation(pathname);
  }, [pathname]);

  return null;
};
